import colors from "../../../styles/colors/colors";

export const DocumentTypeIcon = () => ({
  color: colors.fonts[18],
  padding: "0.3rem 0.5rem 0 0.8rem",
});

export const DocumentDetailsTableCell = () => ({
  padding: "0",
});

export const DocumentData = (isDocNo?: boolean) => ({
  paddingTop: "0.4rem",
  paddingLeft: isDocNo ? "0rem" : "1.1rem",
  textAlign: isDocNo ? "center" : "left",
});

export const DisabledDocumentLink = {
  cursor: "default",
  color: colors.grey[1],
  textDecoration: "none",
  pointerEvents: "none",
};

export const DocumentNameUnderline = {
  textDecoration: "none",
};

export const DocumentName = {
  overflow: "hidden",
  display: "block",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  maxWidth: "10rem",
  textDecoration: "unset",
};

export const MainContainer = {
  padding: "1rem",
  backgroundColor: colors.white[1],
};
